import axios from "axios";
import { IBookingAncillary } from "../../types";

export interface IGetBookingAncillariesReturn {
    ancillaries: IBookingAncillary[]
}

export const getBookingAncillaries = async (): Promise<IGetBookingAncillariesReturn> => {
    const response = await axios.get('/booking/search/ancillaries');
    return response.data;
};
